// extracted by mini-css-extract-plugin
export default {"root":"DMActionsTableHead_root__PVs1U"};